import React from 'react';
import clsx from 'clsx';

import { Input } from '@auspost/postmaster-react';

import {
  INLINE_VALIDATION_TEST_ID,
  NICKNAME_INPUT_TEST_ID,
} from 'App/DetailsPage/SummaryPanel/Nickname/Nickname.test-ids';
import { CommonClass } from 'config/track-config';

import styles from './NicknameInput.module.scss';

interface NicknameInputProp {
  inputValue: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  nicknameId?: string;
  ariaLabel?: string;
}

const NicknameInput: React.FC<NicknameInputProp> = ({ inputValue, onChange, onKeyDown, nicknameId, ariaLabel }) => {
  const [isValid, setIsValid] = React.useState(true);
  const nicknameInputRef = React.createRef<HTMLInputElement>();

  // check inline validation for special characters
  React.useEffect(() => {
    const newValid = nicknameInputRef.current?.checkValidity();
    setIsValid(!!newValid);
  }, [inputValue]);

  // set focus on nickname input when open
  React.useEffect(() => {
    if (nicknameInputRef.current) {
      nicknameInputRef.current.focus();
    }
  });

  return (
    <>
      {!isValid && (
        <label data-testid={INLINE_VALIDATION_TEST_ID} htmlFor='edit-nickname-input' role='alert'>
          Invalid nickname, special characters are not permitted.
        </label>
      )}

      <Input
        type='text'
        id={nicknameId}
        defaultValue={inputValue}
        maxLength={30}
        aria-label={ariaLabel}
        className={clsx(styles.nicknameFormInput, CommonClass.FULLSTORY_MASK)}
        pattern='^[\w!#$%&amp;\(\)*+, .\\\/:;<=>?@\[\]^`\{\|\}~&apos;"\-]*$'
        autoComplete='off'
        onKeyDown={onKeyDown}
        onChange={onChange}
        ref={nicknameInputRef}
        data-testid={NICKNAME_INPUT_TEST_ID}
        aria-invalid={isValid}
      />
    </>
  );
};

export default NicknameInput;
